export default "__VITE_ASSET__e6bb2862__"